module.exports = __webpack_public_path__ + "fonts/8a8568451876609f45d33db9e95189aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 285
// module chunks = 0